import { useGoogleOAuthRedirectPageBehavior } from "@/pages/google-oauth-redirect/utils";
import { LoadingOverlay } from "@/components/overlay/loading";
import React, { FC } from "react";

export const GoogleOAuthRedirectPage: FC = () => {
  const state = useGoogleOAuthRedirectPageBehavior();

  if (state.error) {
    /**
     * @todo - Can we add better handling based on the error kind here?
     */
    return <div> Something went wrong. Please try again later. </div>;
  }

  return <LoadingOverlay isVisible={true} />;
};
